import Card from '../../../../componentes/contenedores/Card';
import Page from '../../../../componentes/plantilla/Page';
import { useContextEmpleado } from '../../../../contexto/empleado/EmpleadoContext';
import TablaCierre from './TablaBuscarCierre';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { formatoFecha } from '../../../../configuracion/validaciones';
import { CierreListar } from '../../../../configuracion/apiUrls';

const HomeBuscarCierre = () => {
    const { listaCierres, ActualizarLista, setListaCierre } = useContextEmpleado();
    const [fechaFiltro, setFechaFiltro] = useState(formatoFecha(new Date()));
    const [fechaFiltroTemp, setFechaFiltroTemp] = useState(formatoFecha(new Date()));
    const [panelAbierto, setPanelAbierto] = useState(false);

    const datos = {
        titulo: {
            titulo: "Busqueda de los cierres",
            url: "/app/admin/cajero/buscar/cierre",
            tituloUrl: "cierre",
            nombreUrl: "Buscar cierre"
        }
    }
    
    useEffect(() => {
            ActualizarLista(CierreListar, setListaCierre);
        }, []);

    const listaCierresFiltrados = useMemo(() => {
            let registros = listaCierres;
    
            if (fechaFiltro) {
                const fechaDeseada = fechaFiltro;
    
                registros = registros.filter(p => {
                    const fechaCierreFormateada = p.createdAt ? formatoFecha(p.createdAt) : null;
                    return fechaCierreFormateada === fechaDeseada;
                });
            }
    
            return registros;
        }, [listaCierres, fechaFiltro]);
    
        const handleFiltrar = () => {
            setFechaFiltro(fechaFiltroTemp);
            setPanelAbierto(false);
        };
    
        const handleReset = () => {
            setFechaFiltro(moment().format("YYYY-MM-DD"));
            setFechaFiltroTemp(moment().format("YYYY-MM-DD"));
            setPanelAbierto(false);
        };
    
    const renderFilterPanel = () => (
        <div className="mb-4 d-flex justify-content-end">
            <div className="position-relative">
                <button
                    className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                    onClick={() => setPanelAbierto(!panelAbierto)}
                    style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "0.9rem",
                        minWidth: "140px",
                    }}
                >
                    <span className="d-flex align-items-center">
                        <i className="fas fa-filter mx-2"></i>
                        Filtros
                    </span>
                    <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                </button>

                {panelAbierto && (
                    <div
                        className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                        style={{
                            minWidth: "240px",
                            right: 0,
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                            zIndex: 1050,
                        }}
                    >
                        <div className="form-group mb-3">
                            <label htmlFor="fechaFiltroInput" className="form-label fw-bold">Fecha</label>
                            <input
                                id="fechaFiltroInput"
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaFiltroTemp}
                                onChange={(e) => setFechaFiltroTemp(e.target.value)}
                            />
                        </div>

                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                <i className="fas fa-filter mx-1"></i> Filtrar
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                <i className="fas fa-sync-alt mx-1"></i> Reset
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <Page datos={datos}>
            <Card titulo="Lista de Cierres">
                {renderFilterPanel()}
                <TablaCierre datos={listaCierresFiltrados}></TablaCierre>
            </Card>
        </Page>
    )
}

export default HomeBuscarCierre;